import { render, staticRenderFns } from "./DettaglioDomanda.vue?vue&type=template&id=b4c59578&"
import script from "./DettaglioDomanda.vue?vue&type=script&lang=js&"
export * from "./DettaglioDomanda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports